import { POST } from "../../APiHelper/API";

export const undoDeletePlayerAPI = (id, onSuccess, onError) => {
    const data = {
        id: id,
    };
    POST(`/api/v1/leagues/players/undo_remove`, data, onSuccess, onError);
};
